<app-loader></app-loader>
<p-confirmPopup></p-confirmPopup>
<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="search-data">
    <div class="back-outer">

        <p (click)="backRoute()">
            <img src="../../../../../assets/images/fi-rr-arrow-left.svg" alt="left" />
            <span>Back</span>
        </p>

    </div>
    <div class="create-booking">
        <ul>
            <li>
                <div (click)="exportData()" class="booking-inner">
                    <img src="../../../../assets/images/export-list.svg" alt="Export list" />
                    <span>Export</span>
                </div>
            </li>
        </ul>
    </div>
</div>
<div class="date-filter">
    <form [formGroup]="revenueFilterForm">
        <div class="grid">
            <div class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="name">Name</label>
                    <div class="custom-select2">
                        <div class="filter-parking header-filter">
                            <input id="name" type="text" pInputText placeholder="Enter Name" formControlName="name"
                                (keydown.enter)="onSearch()" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="email">Email</label>
                    <div class="custom-select2">
                        <div class="filter-parking header-filter">
                            <input id="email" type="text" pInputText placeholder="Enter Email"
                                formControlName="email" (keydown.enter)="onSearch()" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="invoiceNumber">Invoice Number</label>
                    <div class="custom-select2">
                        <div class="filter-parking header-filter">
                            <input id="invoiceNumber" type="text" pInputText placeholder="Enter Invoice Number"
                                formControlName="invoiceNumber" (keydown.enter)="onSearch()" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="paymentStatus">Payment Status</label>
                    <div class="custom-select2">
                        <div class="filter-parking header-filter">
                            <p-dropdown id="paymentStatus" placeholder="Select Status" [options]="selectPaymentStatus" optionLabel="name"
                                optionValue="value" formControlName="paymentStatus"></p-dropdown>
                            <img src="assets/images/fill-dropdown.svg" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="type">Type</label>
                    <div class="custom-select2">
                        <div class="filter-parking header-filter"></div>
                        <p-dropdown id="type" placeholder="Select" [options]="selectType" optionLabel="name" optionValue="value"
                            formControlName="type"></p-dropdown>
                        <img src="assets/images/fill-dropdown.svg" alt="" />
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-1">
                <div class="date-outer-btn">
                    <div class="edit-outer">
                        <p-button styleClass="p-button search-button" label="Apply Filter"
                            (onClick)="onSearch()"></p-button>
                    </div>
                </div>
            </div>

            <div class="col-12 lg:col-1">
                <div class="date-outer-btn">
                    <div class="edit-outer reset-btn">
                        <p-button styleClass="p-button  p-button-outlined" label="Reset"
                            (onClick)="resetFilter()"></p-button>

                    </div>
                </div>
            </div>

        </div>
    </form>

</div>
<div class="driver-list-outer">
    <div class="list-heading">
        <div class="parking-lot-outer">
            <h4>{{parkingLotName}}</h4>
            <div class="payment-reminder">
                <p>
                    <strong>Selected</strong> - {{selectedProducts?.length || 0}}
                </p>
                <h5 [class.disabled]="!(selectedProducts?.length > 0)"
                    (click)="(selectedProducts?.length > 0) && sendPaymentReminder()">Payment Reminder</h5>
            </div>
        </div>
        <p *ngIf="startDate">{{startDate | date: 'MMM dd, yyyy'}} to {{endDate | date: 'MMM dd, yyyy'}}</p>
    </div>

    <div class="card parking-list booking-table1 fullwidth-table-scroll common-heighttd booking-outer">

        <p-table id="tbl-top" [value]="revenueCollectionData" [(selection)]="selectedProducts" [resizableColumns]="true"
            columnResizeMode="expand">
            <ng-template pTemplate="header">
                <tr>
                    <th scope="col">
                        <div class="type-check"><span>Name</span></div>
                    </th>
                    <th scope="col">Email</th>
                    <th scope="col">Type</th>
                    <th scope="col" class="custom-addres">Status</th>
                    <th scope="col">Last Date for Payment</th>
                    <th scope="col">Invoice Number</th>
                    <th scope="col">Amount ($)</th>
                    <th scope="col">Payment Mode</th>
                    <th scope="col">Booking Start Date</th>
                    <th scope="col">Booking End Date</th>
                    <th scope="col">Time Zone</th>
                    <th scope="col">Start Month</th>
                    <th scope="col">Parking Lot</th>
                    <th scope="col">Booking Type</th>
                    <th scope="col">Billing Cycle</th>
                    <th scope="col">User Type</th>
                    <th scope="col">Reminder Count</th>
                    <th scope="col">Last Reminder</th>
                    <th scope="col">Reason</th>
                    <th scope="col">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
                <tr class="border12">

                    <td>
                        <div class="driver-email"><p-tableCheckbox [value]="rowData" /><span>{{rowData.name}}</span>
                        </div>
                    </td>
                    <td>
                        <div>{{rowData.email || '-'}}</div>
                    </td>
                    <td>
                        <div>{{rowData.type || '-'}}</div>
                    </td>
                    <td>
                        <div class="driver-email">{{rowData.paymentStatus}}</div>
                    </td>
                    <td>
                        <div class="common-payment-status" [ngClass]="getPaymentDateClass(rowData.lastDateForPayment)">
                            {{rowData.lastDateForPayment || '-'}}</div>
                    </td>
                    <td>
                        <div> {{rowData.invoiceNumber}}</div>
                    </td>

                    <td>
                        <div> {{rowData.amount}}</div>
                    </td>
                    <td>
                        <div>{{rowData?.bookingPaymentMode | paymentModeValue}}</div>
                    </td>
                    <td>
                        <div>{{rowData.bookingStartDate || '-'}}</div>
                    </td>
                    <td>
                        <div>{{rowData.bookingEndDate || '-'}}</div>
                    </td>
                    <td>
                        <div>{{rowData.timeZone ? (getTimeZoneAbbreviation(rowData?.timeZone)) : '-'}}</div>
                    </td>

                    <td>
                        <div>{{ rowData.startMonth || '-' }}</div>
                    </td>
                    <td>
                        <div>{{rowData.parkingLotName || '-'}}</div>
                    </td>
                    <td>
                        <div>{{rowData.bookingType || '-'}}</div>
                    </td>
                    <td>
                        <div>{{rowData.billingCycle || '-'}}</div>
                    </td>
                    <td>
                        <div>{{rowData.userType || '-'}}</div>
                    </td>
                    <td>
                        {{rowData.paymentReminderSendCount || '-'}}
                    </td>
                    <td>
                        {{rowData.reminderSendDate || '-'}}
                    </td>
                    <td>
                        <div>{{rowData.paymentFailureReason || '-'}}</div>
                    </td>
                    <td>
                        <div class="export-btn">
                            <img (click)="activeItem = rowData;showData(rowData,$event);menu.toggle($event)"
                                src="assets/images/dashboard-dot.svg" alt="" />
                        </div>
                    </td>

                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
                <tr class="no-border">
                    <td class="no-record" colspan="18">
                        No Record Found
                    </td>
                </tr>
            </ng-template>

        </p-table>

        <div *ngIf="revenueCollectionData?.length > 0" class="card common-content-end custom-pagination2">
            <p-paginator [first]="first" [totalRecords]="totalRecords" [rows]="itemsPerPage"
                (onPageChange)="onPageChange($event)"></p-paginator>
        </div>
    </div>
</div>
<div class="custom-export"> <p-menu #menu [model]="items" [popup]="true"></p-menu>
</div>